import axios from 'axios';
import Vue from 'vue';

/**
 * @method connectBzbsGet
 * @method connectBzbsPost
 * @method connectBzbsPostJson
 * @method connectBzbsGetBlob
 */
export default {
    // /**
    //  * Connect Buzzebees GET method
    //  * @param {string} url string url
    //  * @param {string} token (optional)
    //  * @param {object} data (optional)
    //  * @return Promise
    //  */
    // connectBzbsGet: function (url, token, data) {
    //     var header = {
    //         'App-Id': Vue.bzbsConfig.client_id,
    //         'api-version': Vue.bzbsConfig.api_version,
    //         // 'Content-Type': 'application/x-www-form-urlencoded',
    //         'Ocp-Apim-Subscription-Key': Vue.bzbsConfig.subscription_key,
    //         // 'country-prefix': Vue.bzbsConfig.country_prefix,
    //     };
    //     if (data == null) {
    //         data = {};
    //     }
    //     // data.device_app_id = this.config().client_id;
    //     if (token != null) {
    //         header.Authorization = 'Bearer ' + token;
    //     }
    //     return axios({
    //         method: 'get',
    //         url: url,
    //         params: data,
    //         headers: header,
    //     });
    // },

    // /**
    //  * Connect Buzzebees POST method
    //  * @param {string} url string url
    //  * @param {string} token (optional)
    //  * @param {object} data parameter
    //  * @param {string} uploadKey (optional)
    //  * @param {object} uploadfile (optional)
    //  * @return Promise
    //  */
    // connectBzbsPost: function (url, token, data, uploadKey, uploadfile) {
    //     var header = {
    //         'App-Id': Vue.bzbsConfig.client_id,
    //         'api-version': Vue.bzbsConfig.api_version,
    //         // 'Content-Type': 'application/x-www-form-urlencoded',
    //         'Ocp-Apim-Subscription-Key': Vue.bzbsConfig.subscription_key,
    //         // 'country-prefix': Vue.bzbsConfig.country_prefix,
    //     };
    //     // data.device_app_id = this.config().client_id;
    //     var form = this.arrToFormData(data);
    //     if (uploadKey)
    //         form.append(uploadKey, uploadfile);

    //     if (token != null) {
    //         header.Authorization = 'Bearer ' + token;
    //     }

    //     return axios({
    //         method: 'post',
    //         url: url,
    //         data: form,
    //         headers: header,
    //     });
    // },

    /**
     * Connect Buzzebees GET method
     * @param {string} url string url
     * @param {string} jwt (optional)
     * @param {object} data (optional)
     * @return {Promise}
     */
    connectBzbsGet: function (url, jwt, data) {
        return this.connectMethod(url, jwt, data, 'get');
    },

     /**
     * Connect Buzzebees POST method
     * @param {string} url string url
     * @param {string} jwt (optional)
     * @param {object} data parameter
     * @return {Promise}
     */
    connectBzbsPost: function (url, jwt, data) {
        return this.connectWithBody(url, jwt, data, 'post');
    },

    /**
     * Connect Buzzebees POST method with json body
     * @param {string} url string url
     * @param {string} jwt (optional)
     * @param {object} data parameter
     * @return {Observable}
     */
    connectBzbsPostJson: function (url, jwt, data) {
        return this.connectMethodJson(url, jwt, data, 'post');
    },

    /**
     * Connect Buzzebees with Method
     * @param {string} url string url
     * @param {string} jwt (optional)
     * @param {object} data parameter
     * @param {string} method post, put
     * @return {Promise}
     */
    connectWithBody: async function (url, jwt, data, method) {
        let header = {}
        if (Vue.bzbsConfig.subscription_key != null) {
            header = {
                'App-Id': Vue.bzbsConfig.client_id,
                'Ocp-Apim-Subscription-Key': Vue.bzbsConfig.subscription_key,
                'api-version': Vue.bzbsConfig.api_version,
                'Content-Type': 'multipart/form-data',
            }
        } else {
            header = {
                'App-Id': Vue.bzbsConfig.client_id,
                'Content-Type': 'multipart/form-data',
            }
        }

        let form = this.arrToFormData(data)

        if (jwt != null) {
            header.Authorization = 'Bearer ' + jwt
        }

        try {
            const res = await axios({
                method: method,
                url: url,
                data: form,
                headers: header,
            });
            
            let resData = this.convertResponse(res.data)
    
            if (resData.isError) {
                throw this.setErrorObjStatus200(res, data)
            } else {
                return {
                    data: resData.data,
                    status: res.status,
                    headers: res.headers
                }
            }
        } catch (err) {
            throw this.setErrorObj(err, data)
        }
    },

    /**
     * Connect Buzzebees with Method
     * @param {string} url string url
     * @param {string} jwt (optional)
     * @param {object} data (optional)
     * @param {string} method (required) get, delete
     * @return {Promise}
     */
    connectMethod: async function (url, jwt, data, method) {
        let header = {
            'App-Id': Vue.bzbsConfig.client_id,
            'api-version': Vue.bzbsConfig.api_version,
            'Ocp-Apim-Subscription-Key': Vue.bzbsConfig.subscription_key,
            'Content-Type': 'application/x-www-form-urlencoded',
        }
        if (data == null) {
            data = {}
        }
        if (jwt != null) {
            header.Authorization = 'Bearer ' + jwt
        }

        try {
            const res = await axios({
                method: method,
                url: url,
                params: data,
                headers: header,
            });
            
            let resData = this.convertResponse(res.data)
            
            if (resData.isError) {
                throw this.setErrorObjStatus200(res, data)
            } else {
                return {
                    data: resData.data,
                    status: res.status,
                    headers: res.headers
                }
            }
        } catch (err) {
            throw this.setErrorObj(err, data)
        }
    },

    /**
     * Connect Buzzebees with Method json body
     * @param {string} url string url
     * @param {string} jwt (optional)
     * @param {object} data (optional)
     * @param {string} method (required) post, put
     * @return {Promise}
     */
    connectMethodJson: async function (url, jwt, data, method) {
        let header = {}
        if (Vue.bzbsConfig.subscription_key != null) {
            header = {
                'App-Id': Vue.bzbsConfig.client_id,
                'Ocp-Apim-Subscription-Key': Vue.bzbsConfig.subscription_key,
                'api-version': Vue.bzbsConfig.api_version,
                'Content-Type': 'application/json',
            }
        } else {
            header = {
                'App-Id': Vue.bzbsConfig.client_id,
                'Content-Type': 'application/json',
            }
        }

        if (data == null) {
            data = {}
        }

        if (jwt != null) {
            header.Authorization = 'Bearer ' + jwt
        }

        try {
            const res = await axios({
                method: method,
                url: url,
                data: data,
                headers: header,
            });
            
            let resData = this.convertResponse(res.data)
        
            if (resData.isError) {
                throw this.setErrorObjStatus200(res, data)
            } else {
                return {
                    data: resData.data,
                    status: res.status,
                    headers: res.headers
                }
            }
        } catch (err) {
            throw this.setErrorObj(err, data)
        }
    },

    /**
     * @param {object} res return api response from axios
     * @param {object} data request data
     */
    setErrorObjStatus200: function (res, data) {
        let error = {
            error: res,
            id: null,
            params: data,
        }

        if (res && res.data && res.data.error != null) {
            error = {
                id: res.data.error.Id,
                code: res.data.error.Code,
                message: res.data.error.Message,
                type: res.data.error.Type,
                res: res,
                params: data,
            }
        } else if (res && res.data != null) {
            error = {
                id: null,
                code: res.data.Code,
                message: res.data.Message,
                res: res,
                params: data,
            }
        }
        return error
    },
    
    /**
     * @param {object} res return api response from axios
     * @param {object} data request data
     */
    setErrorObj: function (err, data) {
        let error = {
            error: err,
            id: null,
            params: data,
        }
        if (err.response && err.response.data && err.response.data.error != null) {
            error = {
                id: err.response.data.error.Id || err.response.data.error.id,
                code: err.response.data.error.Code  || err.response.data.error.code,
                message: err.response.data.error.Message || err.response.data.error.message,
                type: err.response.data.error.Type || err.response.data.error.type,
                res: err.response,
                params: data,
            }
        } else {
            var responseObj = err.response || {};
            error = {
                id: responseObj.Id || responseObj.id || null,
                code: responseObj.Code || responseObj.code || null,
                message: responseObj.Message || responseObj.message || null,
                type: '',
                res: err.response,
                params: data,
            }
        }
        return error
    },
    
    /**
     * Convert data to array of FormData
     * @param {Array|Dictionary} arr
     */
    arrToFormData: function (arr) {
        var form = new FormData();
        for (var i in arr) {
            form.append(i, arr[i]);
        }
        return form;
    },

    /**
     * @param {object} res return response api from axios
     * @returns {object} data format
     */
    convertResponse: function (res) {
        let data = res.Data ? res.Data : res;

        if (data.Success === true || data.Success === false) {

            let actualData = data.Data ? data.Data : data;
            return {
                isError: data.Success ? false : true,
                data: actualData,
            };
        } else {
            return {
                isError: false,
                data: data,
            };
        }
    },

    /**
     * Connect Buzzebees GET Blob
     * @param {string} url string url
     * @return Promise
     */
    connectBzbsGetBlob: function (url) {
        return axios({
            method: 'get',
            url: url,
        });
    },
}
